module.exports = __webpack_public_path__ + "media/images/flags/ir-d09393ee87fcd68d7067c4d2137f9203.svg";